import { Link, Navigate, useLocation } from "react-router-dom";
import { CheckCircle2, MessageSquare } from "lucide-react";
import { eur } from "@/lib/api";
import { BankTransferInfo } from "@/components/club/BankTransferInfo";

export default function OrderConfirmed() {
  const { state } = useLocation();
  const orders = state?.orders || [];
  if (!orders.length) return <Navigate to="/account" replace />;
  const due = orders.reduce((s, o) => s + o.amount_due, 0);
  return (
    <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6" data-testid="order-confirmed-page">
      <CheckCircle2 className="h-12 w-12 text-emerald-400" />
      <h1 className="mt-4 font-display text-4xl font-extrabold text-white">Ordine ricevuto!</h1>
      <p className="mt-3 flex items-center gap-2 text-slate-400"><MessageSquare className="h-4 w-4" /> Ti abbiamo inviato un SMS con il riepilogo; anche l'Admin è stato avvisato.</p>
      {due > 0 && <p className="mt-2 text-slate-300">Totale da bonificare: <b data-testid="confirmed-total-due" className="text-white">{eur(due)}</b>{orders.length > 1 && " (un bonifico per ogni ordine, con la sua causale)"}</p>}
      <div className="mt-8 space-y-6">
        {orders.map((o) => (
          <div key={o.id} className="space-y-3">
            <p className="text-sm text-slate-400">Ordine <b className="text-white">{o.causale}</b>{o.partner_name ? ` · ${o.partner_name}` : ""}{o.points_used > 0 ? ` · ${o.points_used} punti usati (−${eur(o.points_discount)})` : ""}</p>
            <BankTransferInfo order={o} />
          </div>
        ))}
      </div>
      <Link to="/account" data-testid="go-to-orders" className="mt-10 inline-block rounded-full bg-amber-500 px-6 py-3 font-semibold text-black hover:bg-amber-400">Vai ai miei ordini</Link>
    </div>
  );
}
